import { Controller } from "@hotwired/stimulus"
import EmblaCarousel from 'embla-carousel'
import Autoplay from 'embla-carousel-autoplay'

export default class extends Controller {
  static values = {
    options: { type: Object, default: { loop: true, slidesToScroll: 'auto', align: 'start' } }
  }

  static targets = ["viewport", "dots"]

  connect() {
    this.emblaApi = EmblaCarousel(
      this.viewportTarget, 
      this.optionsValue, 
      [Autoplay()]
    )

    this.setupDotButtons()
    this.setupEventListeners()
  }

  disconnect() {
    this.emblaApi.destroy()
    this.removeDotButtons()
  }

  setupDotButtons() {
    this.dotNodes = []

    // Add dot buttons
    this.dotsTarget.innerHTML = this.emblaApi
      .scrollSnapList()
      .map(() => '<button class="embla__dot" type="button" data-action="click->embla-carousel#scrollTo"></button>')
      .join('')

    // Store references to dot nodes
    this.dotNodes = Array.from(this.dotsTarget.querySelectorAll('.embla__dot'))
    
    // Set initial active state
    this.toggleDotButtonsActive()
  }

  scrollTo(event) {
    const index = this.dotNodes.indexOf(event.currentTarget)
    this.emblaApi.scrollTo(index)
    this.handleAutoplay()
  }

  handleAutoplay() {
    const autoplay = this.emblaApi?.plugins()?.autoplay
    if (!autoplay) return

    const resetOrStop = autoplay.options.stopOnInteraction === false 
      ? autoplay.reset 
      : autoplay.stop

    resetOrStop()
  }

  toggleDotButtonsActive() {
    const previous = this.emblaApi.previousScrollSnap()
    const selected = this.emblaApi.selectedScrollSnap()
    
    if (this.dotNodes[previous]) {
      this.dotNodes[previous].classList.remove('embla__dot--selected')
    }
    
    if (this.dotNodes[selected]) {
      this.dotNodes[selected].classList.add('embla__dot--selected')
    }
  }

  removeDotButtons() {
    this.dotsTarget.innerHTML = ''
  }

  setupEventListeners() {
    this.emblaApi
      .on('init', this.setupDotButtons.bind(this))
      .on('reInit', this.setupDotButtons.bind(this))
      .on('init', this.toggleDotButtonsActive.bind(this))
      .on('reInit', this.toggleDotButtonsActive.bind(this))
      .on('select', this.toggleDotButtonsActive.bind(this))
  }
}